import request from '@/utils/request'

/**
 * 分页获取订单列表
 * http://yapi.wahool.com/project/29/interface/api/6180
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getOrderManageTableData(data = {}) {
  return request.GET('/supplier/order/page', data)
}

/**
 * 订单详情
 * http://yapi.wahool.com/project/29/interface/api/6187
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getOrderManageDetail(data = {}) {
  return request.GET('/supplier/order/get', data)
}

/**
 * 接单
 * http://yapi.wahool.com/project/29/interface/api/6194
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function acceptOrder(data = {}) {
  return request.POST('/supplier/order/accept', data)
}

/**
 * 异议
 * http://yapi.wahool.com/project/29/interface/api/6201
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function dissentOrder(data = {}) {
  return request.POST(`/supplier/order/dissent`, data)
}

/**
 * 订单详情导出
 * http://yapi.wahool.com/project/29/interface/api/6250
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function exportOrder(data = {}) {
  return request.GET('/supplier/order/export', data, { responseType: 'blob' })
}

/**
 * 订单发货详情
 * http://yapi.wahool.com/project/29/interface/api/6257
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getOrderManageShippingDetail(data = {}) {
  return request.GET('/supplier/order/getShipping', data)
}

/**
 * 创建发货单
 * http://yapi.wahool.com/project/29/interface/api/6306
 * 谢高仁
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function createShipping(data = {}) {
  return request.POST(`/supplier/shipping/create`, data)
}

/**
 * 导出退款单明细
 * 窦哥
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function exportDeductionDetailApi(data = {}) {
  return request.GET('/supplier/compensation-deduction-orders/export', data, { responseType: 'blob' })
}

/**
 * 获取日志列表
 * http://yapi.wahool.com/project/29/interface/api/6397
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getOperationLog(data = {}) {
  return request.GET('/supplier/operation-log/list', data)
}

/**
 * 获取订单个数
 * http://yapi.wahool.com/project/29/interface/api/6502
 * 邢心平
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getOrderManageTotalsData(data = {}) {
  return request.GET('/supplier/order/listCount', data)
}
/**
 * 获取支付类型
 * http://yapi.wahool.com/project/29/interface/api/8511
 * 窦
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getPaymentMethodApi(data = {}) {
  return request.GET('/supplier/compensation-deduction-orders/payment-method', data)
}
/**
 * 获取扣款类型
 * http://yapi.wahool.com/project/29/interface/api/8505
 * 窦
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getDeductTypeApi(data = {}) {
  return request.GET('/supplier/compensation-deduction-orders/type', data)
}
/**
 * tab汇总
 * http://yapi.wahool.com/project/29/interface/api/8499
 * 窦
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getTabSummaryApi(data = {}) {
  return request.GET('/supplier/compensation-deduction-orders/summary', data)
}
/**
 * 获取列表数据
 * http://yapi.wahool.com/project/29/interface/api/8493
 * 窦
 * @param data
 * @returns {Promise | Promise<any>}
 */
export function getTableApi(data = {}) {
  return request.GET('/supplier/compensation-deduction-orders/page', data)
}
